export enum PageName {
    DASHBOARD="dashboard",
    ALLJOBPAGE = "ALLJOBPAGE",
    SAVEDJOBPAGE = "SAVEDJOBPAGE",
    PENDINGLISTJOBPAGE = "PENDINGLISTJOBPAGE",
    JOBALERTLISTPAGE = "JobAlertListPage",
    ADMINSUBMISSIONACTIVE = "AdminSubmissionActivePage",
    RecruiterList = "RecruiterList"
  }